import React from 'react';
import { Select } from 'antd';
import _ from 'lodash';
import Button from '../../../../components/Button/Button';
import './ThemeSelect.scss';

const { Option } = Select;

const getKey = (item, index) => `${index}_${item}`;

const getThemeColors = (value) => {
  // Legacy flat theme: colorTitle / colorBg1 / colorBg2 / colorBar
  if ('colorBg1' in value) return _.values(value);

  // Structured theme (e.g. Marsh): four distinct brand swatches
  return [
    value.headings?.h1?.color,
    value.link?.color,
    value.visuals?.divider?.color,
    value.link?.visited || value.body?.color,
  ].filter(Boolean);
};

const getOptions = ({ value }) =>
  getThemeColors(value).map((color, index) => (
    <div key={getKey(color, index)} style={{ backgroundColor: color }} className="report-theme-select-colors" />
  ));


export default ({ themes, selectedTheme, onThemeSelect, hideCustomThemeButton }) => (
  <div className="report-theme-select">
    <Select size="large" value={selectedTheme.id} onChange={onThemeSelect}>
      {themes.map((item) => (
        <Option key={item.id}>
          <div title={item.label} className="report-theme-select-option">
            {getOptions(item)}
          </div>
        </Option>
      ))}
    </Select>
    {!hideCustomThemeButton && (
      <Button
        type="primary"
        href="https://lmigroup.io/product-tag/eservice-customisation/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Custom theme $499
      </Button>
    )}
  </div>
);
